import { type ReactElement } from 'react';

import {
  RiCodeLine as CodeIcon,
  RiGroupFill as GroupIcon,
  RiUserFill as PersonIcon,
  RiGlobalLine as PublicIcon,
  RiRobot2Fill as RobotIcon,
  RiSettings3Fill as SettingsIcon,
} from '@remixicon/react';

import { IdentityKind } from '../../utils';

const AVATAR_ICON_SIZE = '1.2em';

export const getIdentityKindIcon = (
  kind: IdentityKind | undefined,
): ReactElement | null => {
  switch (kind) {
    case 'user':
      return <PersonIcon size={AVATAR_ICON_SIZE} />;
    case 'apiClient':
      return <CodeIcon size={AVATAR_ICON_SIZE} />;
    case 'service':
      return <SettingsIcon size={AVATAR_ICON_SIZE} />;
    case 'group':
      return <GroupIcon size={AVATAR_ICON_SIZE} />;
    case 'everyone':
      return <PublicIcon size={AVATAR_ICON_SIZE} />;
    case 'agent':
      return <RobotIcon size={AVATAR_ICON_SIZE} />;
    default:
      return null;
  }
};
